import { render, staticRenderFns } from "./Transfer_goods_detail.vue?vue&type=template&id=49a07bdc&scoped=true&"
import script from "./Transfer_goods_detail.vue?vue&type=script&lang=js&"
export * from "./Transfer_goods_detail.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_goods_detail.vue?vue&type=style&index=0&id=49a07bdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a07bdc",
  null
  
)

export default component.exports